import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { ConfigProvider } from 'antd'; // For Ant Design theme customization (optional)

function App() {
  return (
    <ConfigProvider /* theme={{ token: { colorPrimary: '#00b96b' } }} */ >
      {/* <GlobalStyle /> */}
      <Router>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Router>
    </ConfigProvider>
  );
}

export default App;